// Libraries
import React from "react";
import styled from "styled-components";
import LogoutIcon from "@mui/icons-material/Logout";
import { Button } from "react-bootstrap";
import HabilisLogo from "../../assets/icons/habilis_logo_new.png";

// Styles
// import "../ChatApp.scss";
import "../styles/reset.css";
import "react-toastify/dist/ReactToastify.css";

// import QueryStatsIcon from "@mui/icons-material/QueryStats";
import MenuIcon from "@mui/icons-material/Menu";

// Assets
// import logo from "../../assets/icons/Kbr.png";
import logo from "../../assets/icons/KbrNew.png";
import HomeIcon from "@mui/icons-material/Home";
import { useNavigate } from "react-router-dom";
import "../upload/fileuploader.scss";
import { Autocomplete, TextField } from "@mui/material";
import { Language_Models } from "../../constants/AppConstant";

export const TopStrip = styled.div`
  background-color: #004987;
  display: flex;
  padding: 5px;
  text-align: center;
  color: white;
  flex-shrink: 0;
  width: 100%;
  border: 2px ridge;
`;

function Header({
  showSidebar,
  setShowSidebar,
  showCreateButton,
  handleModalOpen,
  languageModel,
  setLanguageModel,
  showLanguageModels,
  showLogoutButton,
  handleLogOut,
  handleCreate,
  showHomeButton,
  isHistroyComp,
}) {
  const navigate = useNavigate();

  return (
    <TopStrip
      style={isHistroyComp ? styles.topStripStyleHistory : styles.topStripStyle}
    >
      <div
        className="pr-2 m-auto d-flex custom-cursor-pointer"
        onClick={() => {
          setShowSidebar(!showSidebar);
        }}
      >
        <MenuIcon className="fs-1" />
      </div>
      <div
        style={{
          padding: "2px",
          backgroundColor: "white",
          borderRadius: "4px",
          margin: "2px 0px",
        }}
      >
        <img
          src={logo}
          height="65px"
          width="85px"
          alt="KBR"
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            navigate("/");
          }}
        />
      </div>

      <div
        className="custom-dropdown"
        style={{
          flex: 1,
          position: "relative",
          // top: "20px",
          fontWeight: "bold",
          fontSize: "20px",
        }}
      >
        {/* {renderDropDown()} */}
        <div>
          {/* <span>KBR Secure Advanced Analytics Platform</span>
              <br /> */}
          <span className="mobSubheader">Habilis - Data to Decision (D2D)</span>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          renderDropDownalignItems: "center",
          fontSize: "12px",
          alignItems: "center",
        }}
      >
        <>
          <img
            src={HabilisLogo}
            style={{
              height: "44px",
              width: "auto",
              borderRadius: "4px",
              backgroundColor: "white",
              paddingLeft: "1.5px",
              marginRight: "5px",
            }}
            alt="habilis-logo"
          />
          {showCreateButton && (
            <div className="button-container">
              <button
                className="upload-button"
                style={{ marginTop: "0px", marginBottom: "0px" }}
                onClick={() => {
                  handleCreate("create");
                }}
              >
                Create Project
              </button>
            </div>
          )}

          {showLanguageModels && (
            <Autocomplete
              disableClearable
              value={languageModel}
              defaultValue={languageModel}
              onChange={(event, newValue) => {
                setLanguageModel(newValue);
              }}
              size="small"
              options={Language_Models}
              getOptionLabel={(option) => option.title}
              sx={{
                width: "300px",
                backgroundColor: "white",
                borderRadius: "5px !important",
                marginRight: "5px",
                marginLeft: "10px",
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // variant="standard"
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "5px !important",
                  }}
                  // label="Language Model *"
                  placeholder="Language Model *"
                />
              )}
            />
          )}

          {showHomeButton && (
            <div style={{ color: "white" }}>
              <Button
                style={{ backgroundColor: "#004987", borderColor: "#004987" }}
                onClick={() => {
                  navigate("/");
                }}
              >
                <HomeIcon titleAccess="Back to home" />
              </Button>
            </div>
          )}
          {showLogoutButton && (
            <div style={{ color: "white" }}>
              <Button
                style={{ backgroundColor: "#004987", borderColor: "#004987" }}
                onClick={() => {
                  handleLogOut();
                }}
              >
                <LogoutIcon titleAccess="Logout" />
              </Button>
            </div>
          )}
        </>
      </div>
    </TopStrip>
  );
}

export default Header;

const styles = {
  topStripStyle: {
    position: "fixed",
    zIndex: "3",
    height: "68.5px",
    alignItems: "center",
    top:"0px"
  },
  topStripStyleHistory: {
    alignItems: "center",
  },
};
